import type { AiMessage } from '../ai/taskStore'

/** 展示 Agent 实际写入过的工作区入口；链接文案不暴露内部资源 ID。 */
export function AssistantWorkspaceLinks({ message }: { message: AiMessage }) {
  const links = (message.workspaceLinks || []).filter(item => typeof item.url === 'string' && typeof item.label === 'string')
  if (!links.length) return null
  return <div className="assistant-links assistant-workspace-links" aria-label="已编辑内容">
    {links.map((item, index) => <a className="assistant-link" href={String(item.url)} key={`${String(item.url)}-${index}`}>
      <i className="ri-external-link-line" aria-hidden="true" />
      {String(item.label)}{item.title ? `：${String(item.title)}` : ''} →
    </a>)}
  </div>
}
